export default __webpack_public_path__ + "static/media/plaid-logo.189841ad.png";